<template>
  <div v-show="!eager" @click="handleClick">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import type { ToastPayload } from '@app/shared/types/toast'

import { camelizeKeys } from 'humps'
import { useToastStore } from '@app/shared/pinia/toast'
import getPiniaInstance from '@app/shared/pinia/instance'

interface Props {
  eager?: boolean
  preventDefault?: boolean
  toast: string
}

const { eager, preventDefault, toast = '{}' } = defineProps<Props>()

const toastStore = useToastStore(getPiniaInstance())

const toastPayload = JSON.parse(toast) as ToastPayload

if (eager && Object.keys(toastPayload).length > 0) {
  toastStore.raiseToast(camelizeKeys(toastPayload) as ToastPayload)
}

function handleClick(e: Event) {
  if (preventDefault) {
    e.preventDefault()
  }

  toastStore.raiseToast(camelizeKeys(toastPayload) as ToastPayload)
}
</script>
